import ActivityFormContainer from './app/process/components/activity_form_container.jsx';

import { FormAPI, FlashMessageAPI, ProcessAPI } from 'lecom-api';
import { DocumentActions, DocumentStore } from './app/document/reflux/document_store';
import { ChartActions, ChartStore } from './app/chart/reflux/chart_store';

import ModalEventHandler from './app/modal/events/modal_event_handler';

const API = {
	FormAPI: FormAPI,
	FlashMessageAPI: FlashMessageAPI,
	ProcessAPI: ProcessAPI
}

window.Lecom = {
	components: {
		ActivityFormContainer: ActivityFormContainer
	},
	actions: {
		DocumentActions: DocumentActions,
		ChartActions: ChartActions
	},
	stores: {
		DocumentStore: DocumentStore,
		ChartStore: ChartStore
	},
	eventHandlers: {
		ModalEventHandler: ModalEventHandler
	},
	api: API
}
